export const CLAUSE_KEYWORDS = [
  'MODE',
  'FROM',
  'SHOW',
  'GROUP BY',
  'TIMESERIES',
  'SINCE',
  'DURING',
  'TIMEZONE',
  'WHERE',
  'ORDER BY',
  'LIMIT',
  'OFFSET',
] as const;

export const CLAUSE_KEYWORD_BOUNDARY = CLAUSE_KEYWORDS.join('|');
